// extracted by mini-css-extract-plugin
export default {"link":"style--link--380cb8","linkContent":"style--linkContent--ce02b2","icon":"style--icon--559490"};